import { SourceName, isMobileScreen } from './source-code';

export const createUrlOsbProjects = (project: string, params = ''): string => {
  params = paramsToUrl(params);
  return `${project}?${params}`;
}

const paramsToUrl = (args = ''): string => {
  const sourceInSession = sessionStorage.getItem('source');
  const sourceWebMobile = isMobileScreen() ? SourceName.mobile : SourceName.web;
  const source = sourceInSession === SourceName.fordpass ? sourceInSession : sourceWebMobile;

  return [
    `cat=${sessionStorage.getItem('cat' in sessionStorage ? 'cat' : 'authToken')}`,
    `vin=${sessionStorage.getItem('vin' in sessionStorage ? 'vin' : 'vehicle-carousel-vin')}`,
    `country=${sessionStorage.getItem('country')}`,
    `divisionId=1`,
    `source=${source}`,
    `${args}`
  ].join('&');
}

export const createUrlToLogout = (isProduction: boolean, logout = 'logout'): string => {
  const environment = isProduction ? '' : 'qa';
  clearSession();
  return `https://fp${environment}.agenda.ford.com/#/${logout}`;
}

const clearSession = () => {
  clearCookies();
  window.localStorage.clear();
  window.sessionStorage.clear();
}

const clearCookies = () => {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
  }
};
